import React from "react";
import { ArrowRight, Phone } from "lucide-react";

export const BlogCtaMid = () => (
  <div className="my-10 bg-emerald_deep/[0.04] border border-emerald_deep/10 rounded-xl p-6 md:p-8" data-testid="blog-cta-mid">
    <div className="flex items-start gap-4">
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent/15 flex items-center justify-center mt-0.5">
        <Phone size={18} className="text-accent" />
      </div>
      <div>
        <p className="font-serif text-lg md:text-xl text-emerald_deep italic tracking-tight">
          Struggling with this? Let's talk.
        </p>
        <p className="text-text_muted text-sm mt-1.5 leading-relaxed">
          Book a consultation with our fertility nutrition expert for a personalised plan.
        </p>
        <a
          href="/consultation"
          data-testid="blog-cta-mid-btn"
          className="inline-flex items-center gap-1.5 text-accent text-sm font-semibold mt-3 hover:text-accent_light transition-colors"
        >
          Book Consultation <ArrowRight size={14} />
        </a>
      </div>
    </div>
  </div>
);

export const BlogCtaEnd = () => (
  <div className="mt-12 mb-8 bg-emerald_deep rounded-xl p-8 md:p-10 text-center" data-testid="blog-cta-end">
    <p className="font-serif text-2xl md:text-3xl text-bone italic tracking-tight leading-snug">
      Ready to take the next step?
    </p>
    <p className="text-bone/60 text-sm mt-3 max-w-md mx-auto leading-relaxed">
      Every journey is different. Get a personalised nutrition plan from Fitly India's experts.
    </p>
    <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
      <a
        href="/consultation"
        data-testid="blog-cta-end-consult"
        className="inline-flex items-center gap-2 bg-accent text-emerald_deep px-8 py-3 text-xs tracking-[0.1em] uppercase font-bold hover:bg-accent_light transition-colors rounded-full"
      >
        Book a Consultation <ArrowRight size={14} />
      </a>
      <a
        href="https://wa.me/919108818369?text=Hi!%20I%20read%20your%20blog%20and%20would%20like%20to%20know%20more."
        target="_blank"
        rel="noopener noreferrer"
        data-testid="blog-cta-end-wa"
        className="inline-flex items-center gap-2 border border-bone/20 text-bone px-8 py-3 text-xs tracking-[0.1em] uppercase font-medium hover:bg-bone/10 transition-colors rounded-full"
      >
        Message on WhatsApp
      </a>
    </div>
  </div>
);
